import { TRACK_DAYS } from './days';
import type { Localized, TrackDay } from './types';

export const TRACK_LENGTH = TRACK_DAYS.length;
export const TRACK_WEEKS = TRACK_LENGTH / 7;

export interface TrackPosition {
  /** 1 to TRACK_LENGTH. */
  day: number;
  /** 1 to TRACK_WEEKS. */
  week: number;
  /** 1 on the first pass; the track starts over when the exam is further away than its length. */
  round: number;
  lesson: TrackDay;
  /** Tomorrow's lesson, or null on the plan's last day. */
  next: TrackDay | null;
}

/**
 * Where a plan day falls on the track. `planDay` is the roadmap's 1-based day; `planDays` its total, so the last day
 * of the plan has no "tomorrow".
 */
export function trackPosition(planDay: number, planDays: number): TrackPosition {
  const index = (Math.max(1, planDay) - 1) % TRACK_LENGTH;
  const day = index + 1;
  return {
    day,
    week: Math.ceil(day / 7),
    round: Math.floor((Math.max(1, planDay) - 1) / TRACK_LENGTH) + 1,
    lesson: TRACK_DAYS[index],
    next: planDay < planDays ? TRACK_DAYS[(index + 1) % TRACK_LENGTH] : null,
  };
}

/** The copy for the app language, Uzbek for one the track has no copy in. */
export function localized(text: Localized, language: string | undefined): string {
  const lang = (language ?? '').slice(0, 2);
  return lang === 'ru' || lang === 'en' ? text[lang] : text.uz;
}
